import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const RatingCard = ({ staffName, onDone }) => {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await api.post("/chat/rating", { stars, comment });
      toast.success("Terima kasih atas penilaian Anda");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-3 mb-2 bg-white keep-white rounded-2xl shadow-lg border border-amber-100 p-4 text-center" data-testid="chat-rating-card">
      <div className="text-sm font-bold text-slate-900">Bagaimana pelayanan {staffName || "admin"}?</div>
      <div className="flex justify-center gap-1.5 my-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} onClick={() => setStars(n)} data-testid={`chat-rating-star-${n}`} aria-label={`${n} bintang`} className="transition-transform active:scale-90">
            <Star className={`h-8 w-8 ${n <= stars ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
          </button>
        ))}
      </div>
      <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={2} maxLength={500} placeholder="Komentar (opsional)"
        data-testid="chat-rating-comment" className="w-full text-sm rounded-xl border border-slate-200 px-3 py-2 outline-none focus:ring-2 focus:ring-amber-300 text-slate-900 bg-white keep-white" />
      <button onClick={send} disabled={!stars || busy} data-testid="chat-rating-submit"
        className="mt-2 w-full bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-white font-semibold py-2.5 rounded-xl text-sm">{busy ? "Mengirim..." : "Kirim Penilaian"}</button>
    </div>
  );
};
